// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1mwsd","footer":"ModalUpdate_footer__3PmrR"};